<template>
  <div class="login-container">
    <header class="login-header">
      <div class="container1">
        <div class="logo">
          <div class="title">Offerta</div>
          <h3>Describe It. Offerta Delivers It.</h3>
        </div>
      </div>
    </header>
    <main class="container">
      <div class="login-card">
        <h1 class="login-title">Sign in to Offerta</h1>
        <form @submit.prevent="handleLogin">
          <div class="form-group">
            <label for="email">Email</label>
            <input type="email" id="email" v-model="email" :class="{ 'border-red-500': errors.email }" />
            <span class="error-message" v-if="errors.email">{{ errors.email }}</span>
          </div>
          <div class="form-group">
            <label for="password">Password</label>
            <input type="password" id="password" v-model="password" :class="{ 'border-red-500': errors.password }" />
            <span class="error-message" v-if="errors.password">{{ errors.password }}</span>
          </div>
          <div class="error-message mt-4 mb-6" v-if="loginError">{{ loginError }}</div>
          <button type="submit" class="btn btn-primary" :disabled="loading">
            <span v-if="loading">Signing in...</span>
            <span v-else>Sign in</span>
          </button>
        </form>
      </div>
    </main>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { supabase } from '../supabase';
const email = ref('');
const password = ref('');
const errors = ref({});
const loading = ref(false);
const loginError = ref('');
const router = useRouter();

const baseUrl = process.env.VUE_APP_API_BASE_URL || ''

function validateForm() {
  errors.value = {};
  let isValid = true;
  if (!email.value) {
    errors.value.email = 'Email is required';
    isValid = false;
  } else if (!isValidEmail(email.value)) {
    errors.value.email = 'Please enter a valid email address';
    isValid = false;
  }
  if (!password.value) {
    errors.value.password = 'Password is required';
    isValid = false;
  }
  return isValid;
}
function isValidEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
async function handleLogin() {
  if (!validateForm()) return;

  /* 
    user1: Landon@gmail.com / Landon0052
    user2: Toms@gmail.com / Toms921023
    user3: Mason@gmail.com / Mason6244

    BayAreaCindyYang@gmail.com / BayAreaCindyYang5221
    ongoing@gmail.com / ongoing9552
  */
  // if (email.value === 'Landon@gmail.com' || email.value === 'Toms@gmail.com' || email.value === 'Mason@gmail.com' || email.value === 'BayAreaCindyYang@gmail.com' || email.value === 'ongoing@gmail.com') {
  //   if (email.value === 'Landon@gmail.com' && password.value !== 'Landon0052') return loginError.value = 'Wrong email or password';
  //   if (email.value === 'Toms@gmail.com' && password.value !== 'Toms921023') return loginError.value = 'Wrong email or password';
  //   if (email.value === 'Mason@gmail.com' && password.value !== 'Mason6244') return loginError.value = 'Wrong email or password';

  //   if (email.value === 'BayAreaCindyYang@gmail.com' && password.value !== 'BayAreaCindyYang5221') return loginError.value = 'Wrong email or password';
  //   if (email.value === 'ongoing@gmail.com' && password.value !== 'ongoing9552') return loginError.value = 'Wrong email or password';

  //   if (email.value === 'BayAreaCindyYang@gmail.com') {
  //     sessionStorage.setItem('user', 'BayAreaCindyYang');
  //   }
  //   if (email.value === 'ongoing@gmail.com') {
  //     sessionStorage.setItem('user', 'ongoing');
  //   }
  // } else {
  //   return loginError.value = 'Wrong email or password';
  // }

  loading.value = true;
  loginError.value = '';
  try {
    // Sign in with Supabase Auth
    const { data, error } = await supabase.auth.signInWithPassword({
      email: email.value,
      password: password.value
    });

    if (error) {
      loginError.value = error.message || 'Login failed. Please check your credentials.';
      return;
    }

    if (data.session) {
      // Store the access token
      sessionStorage.setItem('token', data.session.access_token);

      // Fetch user profile from backend
      const response = await fetch(baseUrl + '/user', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${data.session.access_token}`
        }
      });

      if (response.ok) {
        const result = await response.json();
        sessionStorage.setItem('userInfo', JSON.stringify(result.data));
        router.push('/dashboard');
      } else {
        loginError.value = 'Failed to fetch user information';
      }
    }
  } catch (error) {
    console.log({error});
    loginError.value = 'Login failed. Please check your credentials.';
  } finally {
    loading.value = false;
  }
}
</script>

<style scope>
.logo {
  color: #fff;
  font-size: 20px;
}
.logo .title {
  font-size: 30px;
  font-weight: 600;
}
</style>
